import { useMutation } from '@tanstack/react-query';
import aiUseCaseV2 from '../../factories/v2/ai';

export const useTranslateContentV2 = () => {
  return useMutation({
    mutationFn: aiUseCaseV2.translateContent,
  });
};
